module.exports = __webpack_public_path__ + "static/media/modal.c56a3101.png";